/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


GorgiasChat.init().then(function () {

    var timer = setInterval(function () {
        var chatButtonHead = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-button')?.contentWindow.document.querySelector('head');
        if (![...chatButtonHead?.children].some(x => x.getAttribute("data-emotion"))) {
            return;
        }
        clearInterval(timer);

        var buttonStyle = document.createElement('style');
        buttonStyle.textContent = '#gorgias-chat-messenger-button {background-color: #00123b !Important; transition: background-color 300ms ease; border-radius: 0 !important; width: 40px; height: 40px;}'; // the custom CSS for the chat button
        chatButtonHead.appendChild(buttonStyle);
    }, 50);
})


// Use this script to customize the chat window.

GorgiasChat.init().then(function () {
    GorgiasChat.on('widget:opened', function () {
        var timer = setInterval(function () {
            var chatWindowHead = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-window')?.contentWindow.document.querySelector('head');
            if (![...chatWindowHead?.children].some(x => x.getAttribute("data-emotion"))) {
                return;
            }
            clearInterval(timer);

            var chatStyle = document.createElement('style');
            chatStyle.textContent = '.message-window-iframe-19a382w {box-shadow: none; background-color: #00123b !Important; padding-top: 18%}'; // window header green
            chatWindowHead.appendChild(chatStyle);
        }, 50);
    })

})

GorgiasChat.init().then(async function () {
    var chatElem = document.getElementById("gorgias-chat-container")
    chatElem.style.display = "none";

    function sleep(seconds) {
        return new Promise(resolve => setTimeout(resolve, seconds * 1000));
    }

    await sleep(3) // CHANGE THIS VALUE TO THE NUMBER OF SECONDS TO WAIT BEFORE SHOWING THE CHAT BUBBLE 
    chatElem.style.display = "";
})

/**
 * when total amount is over threshold 
 * @free_gift_variant_id :string
 * @free_gift_threshold :number
 * @free_gift_enabled   :boolean
 * 
 */

document.addEventListener("cart:updated", async (event) => {
    try {
        const cart = event.detail.cart
        const totalPrice = parseFloat(cart.original_total_price) / 100
        const isAddedGift = cart.items.find(item => item.id.toString() === free_gift_variant_id.toString())
        if (!isAddedGift && totalPrice >= free_gift_threshold && free_gift_enabled) {
            const lineItem = await addItem(free_gift_variant_id, 1)
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true
            }))
        }
    } catch (error) {
        console.log(error)
    }

})

async function addItem(variantId, quantity, properties = {}) {
    const result = await fetch("/cart/add.json", {
        method: "post",
        headers: {
            "Content-type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            properties: properties
        })
    })

    return result.json()
}

//--- Custom Cart Note JS START ---//

(function ($) {
  $.fn.extend({
    cartNote: function () {
      // Cache the reference to the cart note input field
      var $cartNoteInput = $(this);

      // Function to handle the cart note update
      function updateCartNote() {
        $.ajax({
          url: `${window.themeVariables.routes.cartUrl}/update.js`,
          type: "POST",
          dataType: "json",
          data: JSON.stringify({ note: $cartNoteInput.val() }),
          contentType: "application/json",
          success: function (cartContent) {
            $(document.documentElement).trigger("cart:updated", {
              cart: cartContent,
            });
            $(".store-msg").show().delay(3000).fadeOut();
          },
        });
      }

      // Listen for click event on the "Save Notes" button
      $('body').on('click','.save-notes',function(e){
        e.preventDefault();
        var val = $('#cart-note').val();
        if(val != ''){
          updateCartNote();
        }else{
          return false;
        }
      });
    },
  });
})(jQuery);

$(document).ready(function () {
  $("#cart-note").cartNote();  
});

//--- Custom Cart Note JS END ---//
